import { Modal, Space } from "antd";
import React from "react";
import ComposeMessageForm from "./ComposeMessageForm";

const ComposeMessageModal = ({ visible, onClose, isEditMode, ...formProps }) => {
  return (
    <Modal
      title={
        <Space align="center">
          <span>{isEditMode ? "✏️" : "✉️"}</span>
          <span style={{ fontSize: 16, fontWeight: 600 }}>
            {isEditMode ? "Edit Message" : "New Message"}
          </span>
        </Space>
      }
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={760}
      centered
      destroyOnClose
      bodyStyle={{ padding: "20px 24px", maxHeight: "80vh", overflowY: "auto" }}
    >
      <ComposeMessageForm isEditMode={isEditMode} {...formProps} />
    </Modal>
  );
};

export default ComposeMessageModal;
